var map = {
  "./default.json": [
    "76266"
  ],
  "./msat.json": [
    "97980",
    "541"
  ],
  "./thezone.json": [
    "18102",
    "899"
  ],
  "./elemental.json": [
    "52302",
    "315"
  ],
  "./playtv.json": [
    "33965",
    "702"
  ],
  "./bulsatcom.json": [
    "21225",
    "658"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = function() { return Object.keys(map); };
__rspack_async_context.id = 12392;
module.exports = __rspack_async_context;
